import ico1 from '../icons/icon-1.ico';
import ico2 from '../icons/icon-2.ico';
import ico3 from '../icons/icon-3.ico';
import ico4 from '../icons/icon-4.ico';
import ico5 from '../icons/icon-5.ico';
import ico6 from '../icons/icon-6.ico';
import '../js/favicon.min.js';
import styleFileContent from '../css/style.css';
import 'style';

function loadStyles() {
  const styleEl = document.createElement('style');
  styleEl.textContent = styleFileContent;

  document.head.appendChild(styleEl);
}

function startFaviconAnimation() {
  const icons = [ico1, ico2, ico3, ico4, ico5, ico6];
  favicon.animate(icons, 1000);
}

async function startLinesAnimation() {
  const mainEl = document.getElementById('main-container');
  mainEl.remove();
  loadStyles();
  const sections = Array.from(mainEl.querySelectorAll('.section'))
    .map((section) => Array.from(section.querySelectorAll('.line')))
    .map((lines) =>
      lines.map((lineEl) => ({
        text: lineEl.textContent,
        html: lineEl.innerHTML,
      }))
    );

  for (const messages of sections) {
    const renderSectionEl = document.createElement('div');
    renderSectionEl.classList.add('section');
    document.body.appendChild(renderSectionEl);
    await writeMessages(renderSectionEl, messages);
  }
}

async function writeMessages(container, messages) {
  const delay = 200;
  const charRate = 100;

  for (const message of messages) {
    const line = await writeLine(message.text, container, charRate, delay);
    if (message.html) {
      line.innerHTML = message.html;
    }
    line.scrollIntoView();
  }
}

async function writeLine(message, parent, charRate, delay) {
  return new Promise((resolve) => {
    requestAnimationFrame(async () => {
      const chars = Array.from(message);

      const line = document.createElement('div');
      line.className = 'line';

      const text = document.createElement('span');

      const caret = document.createElement('span');
      caret.className = 'caret';

      line.append(text, caret);

      parent.appendChild(line);

      for (const char of chars) {
        text.textContent += char;
        await sleep(charRate);
      }

      await sleep(delay);
      caret.remove();

      resolve(line);
    });
  });
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

startLinesAnimation();
startFaviconAnimation();
